import platformStore from '@/shared/store/platformStore'

export default platformStore({
  state: {},
})
